var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_c('input-table',{attrs:{"serviceType":_vm.serviceType,"data":_vm.services,"payloadData":_vm.payloadData}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }